import styled from "styled-components"

import logoMarkImg from "assets/img/referral-cta-logo-mark.png"
import thermostatImg from "assets/img/referral-cta-thermostat.png"

import {
  displayFont,
  GradientText,
  mobileBreakpoint,
  ReferrerBadge,
  tabletBreakpoint,
  textDark,
  useReferralAgent,
} from "./shared"

const FooterSection = styled.section`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 24px;
  border-top: 1px solid rgb(255 255 255 / 8%);
  background: #0f1320;
  color: #fff;
  text-align: center;

  @media only screen and (width <= ${mobileBreakpoint}) {
    padding: 64px 20px;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 640px;

  h2 {
    /* the page-level reset (h1,h2,h3 { margin: 0 }) can win the specificity tie, so force it */
    margin-top: 30px !important;
    font-family: ${displayFont};
    font-size: 44px;
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: -1.5px;

    @media only screen and (width <= ${mobileBreakpoint}) {
      font-size: 32px;
      letter-spacing: -1px;
    }
  }

  p {
    margin: 16px 0 28px;
    color: rgb(255 255 255 / 62%);
    font-family: ${displayFont};
    font-size: 1.0625rem;
    font-weight: 300;
    line-height: 1.6;
  }
`

const LogoMark = styled.img`
  position: absolute;
  top: -48px;
  left: -80px;
  width: 600px;
  height: 600px;
  pointer-events: none;
  user-select: none;

  @media only screen and (width <= ${tabletBreakpoint}) {
    width: 420px;
    height: 420px;
  }
`

const Thermostat = styled.img`
  position: absolute;
  right: -60px;
  bottom: -4px;
  width: 320px;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 0 40px 0 rgb(67 224 248 / 15%);
  pointer-events: none;
  user-select: none;

  @media only screen and (width <= ${tabletBreakpoint}) {
    width: 220px;
  }
`

const ApplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 218px;
  min-height: 55px;
  padding: 14px 26px;
  border: none;
  border-radius: 14px;
  background: #7edcf1;
  color: ${textDark};
  cursor: pointer;
  font-family: ${displayFont};
  font-size: 1.0625rem;
  font-weight: 600;
  line-height: 1.2;
  transition: background 0.15s ease;

  &:hover {
    background: #93e3f4;
  }

  @media only screen and (width <= ${mobileBreakpoint}) {
    width: 100%;
  }
`

export const FooterCta = () => {
  const agent = useReferralAgent()
  const firstName = agent?.name.split(" ")[0] ?? "your agent"

  return (
    <FooterSection>
      <LogoMark src={logoMarkImg} alt="" aria-hidden />
      <Thermostat src={thermostatImg} alt="" aria-hidden />
      <Content>
        <ReferrerBadge />
        <h2>
          Your free thermostat
          <br />
          <GradientText>is waiting.</GradientText>
        </h2>
        <p>{`Claim it in about a minute — ${firstName} already covered the hardware and the install.`}</p>
        <ApplyButton type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          Apply now — it&apos;s free
        </ApplyButton>
      </Content>
    </FooterSection>
  )
}
